import { useSelectedUserConfigSlice } from '@/stores/selectors';

import { type ChatIdentityKey, toChatIdentityKey } from './query-keys';

export const useChatIdentityKey = (): ChatIdentityKey => {
  const { selectedUserRole, selectedEntityId } = useSelectedUserConfigSlice();

  return toChatIdentityKey(selectedUserRole, selectedEntityId);
};
